(function($) {

	$.fn.documentGrid = function() {

		return this.each(function() {
			var $this = $(this);

            /**
             * Show document info in tooltip
             */
            $this.find('.document:has(.document-tooltip *)')
                .tooltip({
                    items: '.document',
                    content: function(){
                        var content = $(this).data('content');
                        if(!content) {
                            content = $(this).find('.document-tooltip');
                            $(this).data('content', content);
                        }
                        return content;
                    }
                });

            /**
             * If the user clicks on the documents but not on a link then click the link
             */
            $this.find('.document').click(function(e){
                var $target = $(e.target);
                if($target.parents().andSelf().filter('a').size()==0) {
                    $target.closest('.document').find('.document-name a:first').click();
                }
            });
        });
	};

})(jQuery);